import React from "react";
var __jsx = React.createElement;
import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./Banner.module.css";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import { If } from "@componentsShared/Conditional/If";
import useBoolean from "@hooks/useBoolean";
import { twMerge } from "tailwind-merge";
var Banner = function Banner(_ref) {
  var cityName = _ref.cityName;
  var lang = useLang();
  var _useTranslation = useTranslation(["web_city", "web_common"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var expandableText = useBoolean(false);
  var cityText = tShort("city-page/text", {
    ns: "web_common",
    cityName: cityName
  });
  var text1 = cityText === null || cityText === void 0 ? void 0 : cityText.slice(0, 100);
  var text2 = cityText === null || cityText === void 0 ? void 0 : cityText.slice(100);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.BC_container
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("المدن", {
        ns: "web_common"
      }),
      link: createUrl("/city")
    }, {
      title: cityName
    }]
  }), /*#__PURE__*/React.createElement("h1", null, t("سيارات للبيع في {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("p", null, " ", t("نوصلك المركبة الي بتشتريها من سيارة إلى {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!cityText
  }, /*#__PURE__*/React.createElement("div", {
    id: "city-page-description-container",
    className: "max-w-[540px] md:max-w-[800px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: " rounded pe-6 mt-4 mb-6 py-1 md:py-3 md:ps-1 md:pe-14 md:mb-8 md:mt-0 relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-20 h-20 transform-origin left-[-20px] en:right-[-20px] en:left-[unset] top-[18.85px] absolute opacity-20 rounded-full border-[15px] border-indigo-100 border-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block w-3.5 h-3.5 en:left-[unset] en:right-[59px] left-[59px] top-[26.85px] absolute opacity-20 rounded-full border-2 border-indigo-100 border-solid"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge(!expandableText.value && "line-clamp-1")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-xs font-medium md:text-base leading-6"
  }, text1), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-xs font-medium md:text-base leading-6 ms-0.5"
  }, text2), /*#__PURE__*/React.createElement(If, {
    condition: expandableText.value
  }, /*#__PURE__*/React.createElement("span", {
    onClick: expandableText.setFalse,
    className: "m-0 p-0 text-xs md:text-base text-primary ms-1 cursor-pointer hover:text-primary-120 transition-colors duration-200"
  }, tShort("less")))), /*#__PURE__*/React.createElement(If, {
    condition: !expandableText.value
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center z-[2] md:-ms-1 mt-1 absolute en:left-[unset] en:right-[10px] md:en:right-[38px] left-[10px] bg-[#ebf4fb] ps-1 gap-px md:left-[38px] md:m-0"
  }, /*#__PURE__*/React.createElement("span", null, "..."), /*#__PURE__*/React.createElement("span", {
    onClick: expandableText.setTrue,
    className: "m-0 p-0 text-xs md:text-base text-primary cursor-pointer hover:text-primary-120 transition-colors duration-200"
  }, tShort("more")))))))))));
};
export default Banner;